<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{questionId ? 'Update' : 'Add'}} Additional Question</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="additionalQuestionForm" style="width: 100%;">
          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title" formControlName="title">
              <mat-error *ngIf="additionalQuestionForm.controls['title'].touched && additionalQuestionForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Field Type</mat-label>
                <mat-select formControlName="type">
                  <mat-option value ="Text Input">Text Input</mat-option>
                  <mat-option value="Yes/No">Yes/No</mat-option>
                  <mat-option value="Dropdown">Dropdown</mat-option>
                  <mat-option value="Date">Date</mat-option>
                </mat-select>
                <mat-error *ngIf="additionalQuestionForm.controls['type'].touched && additionalQuestionForm.controls['type'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>

              <ng-container *ngIf="additionalQuestionForm.value.type === 'Dropdown'">
                <div formArrayName="options">
                  <div *ngFor="let option of options.controls; let i = index">
                    <div [formGroupName]="i">
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Options ({{i + 1}})</mat-label>
                        <input matInput placeholder="Options" formControlName="option">
                        <mat-error  *ngIf="option.get('option').hasError('required')">
                          This is a required field.
                        </mat-error>
                        <mat-error  *ngIf="option.get('option').hasError('minlength')">
                          Minimum length should be 2.
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field fxFlex="auto" appearance="outline">
                        <mat-label>Reflected Price ({{i + 1}})</mat-label>
                        <input matInput placeholder="Price" formControlName="price" type="number" min="0" (keypress)="apiService.allowNumbers($event)">
                        <mat-error  *ngIf="option.get('price').hasError('required')">
                          This is a required field.
                        </mat-error>
                      </mat-form-field>
                      <span class="remove" (click)="removeOption(i)" *ngIf="options.controls.length > 1"><mat-icon>clear</mat-icon></span>
                    </div>
                    
                  </div>
                </div> 
                <button type="button" mat-raised-button (click)="addOption()" [disabled]="additionalQuestionForm?.controls?.options?.status === 'INVALID'">
                  <mat-icon>add_circle_outline</mat-icon> Add Option
                </button>
              </ng-container>

              <ng-container *ngIf="additionalQuestionForm.value.type === 'Yes/No'">
                <div class="flex">
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>Yes Reflected Price</mat-label>
                  <input matInput placeholder="Price" formControlName="yes" type="number" min="0" (keypress)="apiService.allowNumbers($event)">
                  <mat-error  *ngIf="additionalQuestionForm.controls['yes'].touched && additionalQuestionForm.controls['yes'].hasError('min')">
                    Minimum value should be 0.
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="auto" appearance="outline">
                  <mat-label>No Reflected Price</mat-label>
                  <input matInput placeholder="Price" formControlName="no" type="number" min="0" (keypress)="apiService.allowNumbers($event)">
                  <mat-error  *ngIf="additionalQuestionForm.controls['no'].touched && additionalQuestionForm.controls['no'].hasError('min')">
                    Minimum value should be 0.
                  </mat-error>
                </mat-form-field>
                </div>
              </ng-container>   

              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Show</mat-label>
                <mat-select formControlName="show">
                  <mat-option value ="after">After</mat-option>
                  <mat-option value="before">Before</mat-option>
                </mat-select>
                <mat-error *ngIf="additionalQuestionForm.controls['show'].touched && additionalQuestionForm.controls['show'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Is Required</mat-label>
              <mat-select formControlName="isRequired">
                <mat-option [value]="true">Yes</mat-option>
                <mat-option [value]="false">No</mat-option>
              </mat-select>
              <mat-error *ngIf="additionalQuestionForm.controls['isRequired'].touched && additionalQuestionForm.controls['isRequired'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Question Type</mat-label>
              <mat-select formControlName="questionTypeId">
                <mat-option value = "">Select question type</mat-option>
                <mat-option *ngFor="let item of additionalQuestionType" [value]="item?.additionalQuestionTypeId">{{item?.title}}</mat-option>
              </mat-select>
              <mat-error *ngIf="additionalQuestionForm.controls['show'].touched && additionalQuestionForm.controls['show'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <div>
               <mat-checkbox formControlName="isDependent">Dependent on another additional question</mat-checkbox>
            </div>
            <ng-container *ngIf="additionalQuestionForm.value?.isDependent">
              <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Question</mat-label>
                <mat-select formControlName="dependentOnQuestion">
                  <mat-option *ngFor="let item of allAdditionalQuestion" [value]="item?.additionalQuestionId">{{item?.title}}</mat-option>
                </mat-select>
                <mat-error *ngIf="additionalQuestionForm.controls['dependentOnQuestion'].touched && additionalQuestionForm.controls['dependentOnQuestion'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
               <mat-form-field fxFlex="auto" appearance="outline">
              <mat-label>Dependent On Answer</mat-label>
              <mat-select formControlName="dependentOnAnswer">
                <mat-option value="Yes">Yes</mat-option>
                <mat-option value="No">No</mat-option>
              </mat-select>
              <mat-error *ngIf="additionalQuestionForm.controls['dependentOnAnswer'].touched && additionalQuestionForm.controls['dependentOnAnswer'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            </ng-container>   
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="addEdit()"><span>{{questionId ? 'Update' : 'Add'}}</span></button>
            <button mat-button type="button" class="can-button" (click)="this.location.back()"><span>Cancel</span></button>
          </div>
          </form>
    </div>
  </div>



